import React, { FC, ReactNode, useEffect, useState } from 'react';
import { Checkbox } from 'snacks-design-system';
import style from './PIECheckbox.module.scss';
interface IPIECheckbox {
  children?: ReactNode;
  id?: string;
  name?: string;
  value?: string;
  checked?: boolean;
  disabled?: boolean;
  autoWidth?: boolean;
  error?: boolean;
  showErrorContainer?: boolean;
  text?: string;
  onChange: (e?: any) => void;
}

export const PIECheckbox: FC<IPIECheckbox> = ({
  children,
  id,
  name,
  value,
  disabled,
  autoWidth,
  error,
  showErrorContainer,
  onChange,
  checked,
}) => {
  const [isSelected, setIsSelected] = useState<boolean | null>(
    typeof checked !== 'boolean' ? false : checked
  );
  const handleOnChange = (element: any) => {
    setIsSelected(element.target.checked);
  };
  useEffect(() => {
    onChange(isSelected);
  }, [isSelected]);
  return (
    <div className={style.PIECheckboxContainer}>
      <Checkbox
        id={id}
        name={name}
        value={value}
        checked={isSelected}
        disabled={disabled}
        modFluid={autoWidth}
        error={error}
        showErrorContainer={showErrorContainer}
        onChange={handleOnChange}
      />

      {children}
    </div>
  );
};

export default PIECheckbox;
